import React from "react";
import "./button.scss";

const Button = ({
  onClick,
  icon: Icon,
  text,
  customClassName = "",
  variant = "default", // "default" | "icon-only"
  disabled = false
}) => {
  return (
    <button
      className={`button button--primary ${customClassName} ${
        variant === "icon-only" ? "button--icon-only" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {Icon && <Icon className="button__icon" />}
      {variant !== "icon-only" && text && <span className="button__text">{text}</span>}
    </button>
  );
};

export default Button;
